import styled from 'styled-components';

type WrapElementsSmallBigProps = {
    isBigScreen: boolean;
};

export const WrapElementsSmallBig = styled.div<WrapElementsSmallBigProps>`
    display: flex;
    /* overflow-x: hidden; */
    flex-direction: ${({ isBigScreen }) => (isBigScreen ? 'row' : 'column')};

    height: 100%;
`;

type ModalShoppingWrapperProps = {
    cartMobileIsOpen: boolean;
};

export const ModalShoppingWrapper = styled.div<ModalShoppingWrapperProps>`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    height: 100%;

    flex: 2;
    transition: flex 0.3s ease-in-out;

    @media (max-width: 768px) {
        overflow: scroll;
        scrollbar-width: none; /* Esconde a barra de rolagem no Firefox */

        &::-webkit-scrollbar {
            display: none; /* Esconde a barra de rolagem no Webkit (Chrome, Safari) */
        }
    }
`;

export const ScrollWrap = styled.div`
    width: 100%;
    height: 100%;

    display: block;
    /* overflow: hidden; */

    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08) inset;
    border-radius: 1.25rem;
`;

export const ShopValuesWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 0.5rem;

    overflow-x: hidden;
    overflow-y: auto;

    padding: 0.75rem;

    @media (max-width: 768px) {
        padding: 0.3rem;
    }
`;

export const HeaderFilters = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
`;

export const ModalFilterHeaderWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    width: fit-content;
    white-space: nowrap;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const WrapperShoppingModal = styled.div`
    height: 100%;
    width: 100%;

    background-color: ${({ theme }) => theme.colors['neutral-50']};
    border-radius: 1.25rem;
    padding: 0.75rem;
    gap: 0.75rem;

    display: flex;
    flex-direction: column;
`;

export const WarnShoppingTextIcon = styled.div`
    height: auto;
    width: 100%;

    background-color: ${({ theme }) => theme.colors['warn-shopping']};
    border-radius: 0.75rem;
    gap: 0.5rem;

    padding: 0.75rem;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TextWarn = styled.span`
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors['text-warn']};
    flex: 1;
`;

type WrapIconCartArrow = {
    isSmallScreen: boolean;
};

export const WrapIconCartArrow = styled.div<WrapIconCartArrow>`
    display: ${({ isSmallScreen }) => (isSmallScreen ? 'none' : 'flex')};
    align-items: start;
    cursor: pointer;
    justify-content: center;

    gap: 0.2rem;
`;
